import ColorPicker from "components/ColorPicker"
import { RadioField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"

const IconTab = ({ isDirty, resetForm, tabIsActive, handleSave }) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader style={{ minWidth: "300px" }}>
          <h4>Icon</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
              <label>Bubble color:</label>
            </Col>
            <Col xs="auto">
              <Field name="bubbleColor" component={ColorPicker} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} sm="auto" className="mt-1">
              <label>Icon color:</label>
            </Col>
            <Col className="mt-1">
              <Row>
                <Col>
                  <Field
                    name="iconColor"
                    type="radio"
                    component={RadioField}
                    label="White"
                    value="1"
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <Field
                    name="iconColor"
                    type="radio"
                    component={RadioField}
                    label="Black"
                    value="2"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.CONTACT_US)(state, ...["design.icon"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.CONTACT_US)),
})

export default connect(mapStateToProps, mapDispatchToProps)(IconTab)
